// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tableHead__ZCYDV {
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
  display: flex;
  align-content: center;
  position: sticky;
  top: 55px;
  z-index: 1;
  padding: 0 50px 0 35px;
  color: var(--tables-title-text);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
  text-transform: uppercase;
  cursor: pointer;
  gap: 10px;
  justify-content: space-between;
}
@media (max-width: 1080px) {
  .tableHead__ZCYDV {
    font-size: 10px;
    padding: 0px 20px 0px 15px;
    gap: 0;
  }
}

.tableHeadFixed__WotSr {
  position: relative;
  top: 0;
}

.tableHeadLocation__drbzA {
  max-width: 250px;
  width: 100%;
  padding: 17px 0;
}
@media (max-width: 1536px) {
  .tableHeadLocation__drbzA {
    max-width: 150px;
    margin-right: 8px;
  }
}
@media (max-width: 1280px) {
  .tableHeadLocation__drbzA {
    max-width: 145px;
    margin-right: 0;
  }
}
@media (max-width: 1080px) {
  .tableHeadLocation__drbzA {
    max-width: 65px;
  }
}
@media (max-width: 850px) {
  .tableHeadLocation__drbzA {
    width: 80px;
    max-width: unset;
    font-size: 8px;
    margin-right: 0;
  }
}

.tableHeadLocationWithoutWo__YknMv {
  max-width: 275px;
}
@media (max-width: 1536px) {
  .tableHeadLocationWithoutWo__YknMv {
    max-width: 160px;
  }
}
@media (max-width: 1280px) {
  .tableHeadLocationWithoutWo__YknMv {
    padding-right: 15px;
  }
}

.tableHeadEquipment__SGzl1 {
  padding: 17px 0;
  max-width: 410px;
  width: 100%;
}
@media (max-width: 1536px) {
  .tableHeadEquipment__SGzl1 {
    max-width: 280px;
  }
}
@media (max-width: 1280px) {
  .tableHeadEquipment__SGzl1 {
    max-width: 170px;
    padding-right: 15px;
  }
}
@media (max-width: 1080px) {
  .tableHeadEquipment__SGzl1 {
    max-width: 135px;
  }
}
@media (max-width: 850px) {
  .tableHeadEquipment__SGzl1 {
    width: 140px;
    max-width: unset;
    font-size: 8px;
    padding-right: 0;
  }
}

.tableHeadEquipmentWithoutWo___CQdO {
  max-width: 425px;
}
@media (max-width: 1536px) {
  .tableHeadEquipmentWithoutWo___CQdO {
    max-width: 345px;
  }
}
@media (max-width: 1280px) {
  .tableHeadEquipmentWithoutWo___CQdO {
    padding-right: 15px;
    max-width: 240px;
  }
}

.tableHeadComponent__GjJBH {
  max-width: 250px;
  width: 100%;
  padding: 17px 0;
}
@media (max-width: 1536px) {
  .tableHeadComponent__GjJBH {
    max-width: 200px;
  }
}
@media (max-width: 1280px) {
  .tableHeadComponent__GjJBH {
    max-width: 150px;
  }
}
@media (max-width: 850px) {
  .tableHeadComponent__GjJBH {
    display: none;
  }
}

.tableHeadComponentWithoutWo__qt9no {
  max-width: 265px;
}
@media (max-width: 1536px) {
  .tableHeadComponentWithoutWo__qt9no {
    max-width: 215px;
  }
}
@media (max-width: 1280px) {
  .tableHeadComponentWithoutWo__qt9no {
    max-width: 165px;
  }
}

.tableHeadType___F9lq {
  padding: 17px 0;
  max-width: 410px;
  width: 100%;
}
@media (max-width: 1536px) {
  .tableHeadType___F9lq {
    max-width: 280px;
  }
}
@media (max-width: 1280px) {
  .tableHeadType___F9lq {
    max-width: 170px;
    padding-right: 15px;
  }
}
@media (max-width: 1080px) {
  .tableHeadType___F9lq {
    max-width: 135px;
  }
}
@media (max-width: 850px) {
  .tableHeadType___F9lq {
    width: 155px;
    max-width: unset;
    font-size: 8px;
    padding-right: 0;
  }
}

.tableHeadTypeWithoutWo__IW00_ {
  max-width: 425px;
}
@media (max-width: 1536px) {
  .tableHeadTypeWithoutWo__IW00_ {
    max-width: 345px;
  }
}
@media (max-width: 1280px) {
  .tableHeadTypeWithoutWo__IW00_ {
    padding-right: 15px;
    max-width: 240px;
  }
}

.tableHeadwWo__t9qNp {
  max-width: 130px;
  width: 100%;
  padding: 17px 0;
}
@media (max-width: 1280px) {
  .tableHeadwWo__t9qNp {
    max-width: 105px;
    margin-right: 15px;
  }
}
@media (max-width: 850px) {
  .tableHeadwWo__t9qNp {
    display: none;
  }
}

.tableHeadTime__DkjIe {
  max-width: 130px;
  width: 100%;
  padding: 17px 0;
}
@media (max-width: 850px) {
  .tableHeadTime__DkjIe {
    width: 50px;
    max-width: unset;
    font-size: 8px;
  }
}

.tableHeadStatus__kpngu {
  padding: 17px 0;
  max-width: 450px;
  width: 100%;
  text-align: end;
}
@media (max-width: 1440px) {
  .tableHeadStatus__kpngu {
    max-width: 280px;
  }
}
@media (max-width: 850px) {
  .tableHeadStatus__kpngu {
    width: 150px;
    font-size: 8px;
  }
}

@media (max-width: 850px) {
  .tableCellsResponseHide__FaO0m {
    display: none;
  }
}

@media (max-width: 850px) {
  .tableBodyRowWo__mGwxP {
    display: none;
  }
}

@media (min-width: 850px) {
  .tableCellsHide__fhg7M {
    display: block;
  }
}

.tableSortIcon__MDY20 {
  outline: none;
  margin-left: 5px;
}
.tableSortIcon__MDY20 path {
  fill: var(--tables-title-icon);
}

.activeSort__Sucwo path {
  fill: var(--tables-primary-row-icon);
}

.smallWidthShow__qVA1N {
  display: none;
}
@media (max-width: 850px) {
  .smallWidthShow__qVA1N {
    display: inline-block;
  }
}

.bigWidthShow__RV6PC {
  display: inline-block;
}
@media (max-width: 850px) {
  .bigWidthShow__RV6PC {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./../src/pages/ActionItems/components/ActionItemsTableHead/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,gDAAA;EACA,mDAAA;EACA,uCAAA;EACA,aAAA;EACA,qBAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,8BAAA;AAzEF;AA2EE;EApBF;IAqBI,eAAA;IACA,0BAAA;IACA,MAAA;EAxEF;AACF;;AA2EA;EACE,kBAAA;EACA,MAAA;AAxEF;;AA2EA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAxEF;AAyEE;EAJF;IAKI,gBAAA;IACA,iBAAA;EAtEF;AACF;AAuEE;EARF;IASI,gBAAA;IACA,eAAA;EApEF;AACF;AAqEE;EAZF;IAaI,eAAA;EAlEF;AACF;AAmEE;EAfF;IAgBI,WAAA;IACA,gBAAA;IACA,cAAA;IACA,eAAA;EAhEF;AACF;;AAmEA;EACE,gBAAA;AAhEF;AAiEE;EAFF;IAGI,gBAAA;EA9DF;AACF;AA+DE;EALF;IAMI,mBAAA;EA5DF;AACF;;AA+DA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AA5DF;AA6DE;EAJF;IAKI,gBAAA;EA1DF;AACF;AA2DE;EAPF;IAQI,gBAAA;IACA,mBAAA;EAxDF;AACF;AAyDE;EAXF;IAYI,gBAAA;EAtDF;AACF;AAuDE;EAdF;IAeI,YAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;EApDF;AACF;;AAuDA;EACE,gBAAA;AApDF;AAqDE;EAFF;IAGI,gBAAA;EAlDF;AACF;AAmDE;EALF;IAMI,mBAAA;IACA,gBAAA;EAhDF;AACF;;AAmDA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAhDF;AAiDE;EAJF;IAKI,gBAAA;EA9CF;AACF;AA+CE;EAPF;IAQI,gBAAA;EA5CF;AACF;AA6CE;EAVF;IAWI,aAAA;EA1CF;AACF;;AA6CA;EACE,gBAAA;AA1CF;AA2CE;EAFF;IAGI,gBAAA;EAxCF;AACF;AAyCE;EALF;IAMI,gBAAA;EAtCF;AACF;;AAyCA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;AAtCF;AAuCE;EAJF;IAKI,gBAAA;EApCF;AACF;AAqCE;EAPF;IAQI,gBAAA;IACA,mBAAA;EAlCF;AACF;AAmCE;EAXF;IAYI,gBAAA;EAhCF;AACF;AAiCE;EAdF;IAeI,YAAA;IACA,gBAAA;IACA,cAAA;IACA,gBAAA;EA9BF;AACF;;AAiCA;EACE,gBAAA;AA9BF;AA+BE;EAFF;IAGI,gBAAA;EA5BF;AACF;AA6BE;EALF;IAMI,mBAAA;IACA,gBAAA;EA1BF;AACF;;AA6BA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AA1BF;AA2BE;EAJF;IAKI,gBAAA;IACA,kBAAA;EAxBF;AACF;AAyBE;EARF;IASI,aAAA;EAtBF;AACF;;AAyBA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;AAtBF;AAuBE;EAJF;IAKI,WAAA;IACA,gBAAA;IACA,cAAA;EApBF;AACF;;AAuBA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;AApBF;AAqBE;EALF;IAMI,gBAAA;EAlBF;AACF;AAmBE;EARF;IASI,YAAA;IACA,cAAA;EAhBF;AACF;;AAoBE;EADF;IAEI,aAAA;EAhBF;AACF;;AAoBE;EADF;IAEI,aAAA;EAhBF;AACF;;AAoBE;EADF;IAEI,cAAA;EAhBF;AACF;;AAmBA;EACE,aAAA;EACA,gBAAA;AAhBF;AAkBE;EACE,8BAAA;AAhBJ;;AAqBE;EACE,oCAAA;AAlBJ;;AAsBA;EACE,aAAA;AAnBF;AAoBE;EAFF;IAGI,qBAAA;EAjBF;AACF;;AAoBA;EACE,qBAAA;AAjBF;AAkBE;EAFF;IAGI,aAAA;EAfF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.tableHead {\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n  display: flex;\n  align-content: center;\n  position: sticky;\n  top: 55px;\n  z-index: 1;\n  padding: 0 50px 0 35px;\n  color: var(--tables-title-text);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 14px;\n  text-transform: uppercase;\n  cursor: pointer;\n  gap: 10px;\n  justify-content: space-between;\n\n  @media (max-width: 1080px) {\n    font-size: 10px;\n    padding: 0px 20px 0px 15px;\n    gap: 0;\n  }\n}\n\n.tableHeadFixed {\n  position: relative;\n  top: 0;\n}\n\n.tableHeadLocation {\n  max-width: 250px;\n  width: 100%;\n  padding: 17px 0;\n  @media (max-width: 1536px) {\n    max-width: 150px;\n    margin-right: 8px;\n  }\n  @media (max-width: 1280px) {\n    max-width: 145px;\n    margin-right: 0;\n  }\n  @media (max-width: 1080px) {\n    max-width: 65px;\n  }\n  @media (max-width: 850px) {\n    width: 80px;\n    max-width: unset;\n    font-size: 8px;\n    margin-right: 0;\n  }\n}\n\n.tableHeadLocationWithoutWo {\n  max-width: 275px;\n  @media (max-width: 1536px) {\n    max-width: 160px;\n  }\n  @media (max-width: 1280px) {\n    padding-right: 15px;\n  }\n}\n\n.tableHeadEquipment {\n  padding: 17px 0;\n  max-width: 410px;\n  width: 100%;\n  @media (max-width: 1536px) {\n    max-width: 280px;\n  }\n  @media (max-width: 1280px) {\n    max-width: 170px;\n    padding-right: 15px;\n  }\n  @media (max-width: 1080px) {\n    max-width: 135px;\n  }\n  @media (max-width: 850px) {\n    width: 140px;\n    max-width: unset;\n    font-size: 8px;\n    padding-right: 0;\n  }\n}\n\n.tableHeadEquipmentWithoutWo {\n  max-width: 425px;\n  @media (max-width: 1536px) {\n    max-width: 345px;\n  }\n  @media (max-width: 1280px) {\n    padding-right: 15px;\n    max-width: 240px;\n  }\n}\n\n.tableHeadComponent {\n  max-width: 250px;\n  width: 100%;\n  padding: 17px 0;\n  @media (max-width: 1536px) {\n    max-width: 200px;\n  }\n  @media (max-width: 1280px) {\n    max-width: 150px;\n  }\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n\n.tableHeadComponentWithoutWo {\n  max-width: 265px;\n  @media (max-width: 1536px) {\n    max-width: 215px;\n  }\n  @media (max-width: 1280px) {\n    max-width: 165px;\n  }\n}\n\n.tableHeadType {\n  padding: 17px 0;\n  max-width: 410px;\n  width: 100%;\n  @media (max-width: 1536px) {\n    max-width: 280px;\n  }\n  @media (max-width: 1280px) {\n    max-width: 170px;\n    padding-right: 15px;\n  }\n  @media (max-width: 1080px) {\n    max-width: 135px;\n  }\n  @media (max-width: 850px) {\n    width: 155px;\n    max-width: unset;\n    font-size: 8px;\n    padding-right: 0;\n  }\n}\n\n.tableHeadTypeWithoutWo {\n  max-width: 425px;\n  @media (max-width: 1536px) {\n    max-width: 345px;\n  }\n  @media (max-width: 1280px) {\n    padding-right: 15px;\n    max-width: 240px;\n  }\n}\n\n.tableHeadwWo {\n  max-width: 130px;\n  width: 100%;\n  padding: 17px 0;\n  @media (max-width: 1280px) {\n    max-width: 105px;\n    margin-right: 15px;\n  }\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n\n.tableHeadTime {\n  max-width: 130px;\n  width: 100%;\n  padding: 17px 0;\n  @media (max-width: 850px) {\n    width: 50px;\n    max-width: unset;\n    font-size: 8px;\n  }\n}\n\n.tableHeadStatus {\n  padding: 17px 0;\n  max-width: 450px;\n  width: 100%;\n  text-align: end;\n  @media (max-width: 1440px) {\n    max-width: 280px;\n  }\n  @media (max-width: 850px) {\n    width: 150px;\n    font-size: 8px;\n  }\n}\n\n.tableCellsResponseHide {\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n\n.tableBodyRowWo {\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n\n.tableCellsHide {\n  @media (min-width: 850px) {\n    display: block;\n  }\n}\n\n.tableSortIcon {\n  outline: none;\n  margin-left: 5px;\n\n  path {\n    fill: var(--tables-title-icon);\n  }\n}\n\n.activeSort {\n  path {\n    fill: var(--tables-primary-row-icon);\n  }\n}\n\n.smallWidthShow {\n  display: none;\n  @media (max-width: 850px) {\n    display: inline-block;\n  }\n}\n\n.bigWidthShow {\n  display: inline-block;\n  @media (max-width: 850px) {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tableHead": `tableHead__ZCYDV`,
	"tableHeadFixed": `tableHeadFixed__WotSr`,
	"tableHeadLocation": `tableHeadLocation__drbzA`,
	"tableHeadLocationWithoutWo": `tableHeadLocationWithoutWo__YknMv`,
	"tableHeadEquipment": `tableHeadEquipment__SGzl1`,
	"tableHeadEquipmentWithoutWo": `tableHeadEquipmentWithoutWo___CQdO`,
	"tableHeadComponent": `tableHeadComponent__GjJBH`,
	"tableHeadComponentWithoutWo": `tableHeadComponentWithoutWo__qt9no`,
	"tableHeadType": `tableHeadType___F9lq`,
	"tableHeadTypeWithoutWo": `tableHeadTypeWithoutWo__IW00_`,
	"tableHeadwWo": `tableHeadwWo__t9qNp`,
	"tableHeadTime": `tableHeadTime__DkjIe`,
	"tableHeadStatus": `tableHeadStatus__kpngu`,
	"tableCellsResponseHide": `tableCellsResponseHide__FaO0m`,
	"tableBodyRowWo": `tableBodyRowWo__mGwxP`,
	"tableCellsHide": `tableCellsHide__fhg7M`,
	"tableSortIcon": `tableSortIcon__MDY20`,
	"activeSort": `activeSort__Sucwo`,
	"smallWidthShow": `smallWidthShow__qVA1N`,
	"bigWidthShow": `bigWidthShow__RV6PC`
};
module.exports = ___CSS_LOADER_EXPORT___;
